/**
 * Provides JS functionality for doctor pronunciation on hero.
 */
(function (Drupal) {
  Drupal.behaviors.pronunciation = {
    attach: function (context, settings) {
      // We use `context` to ensure this only runs on elements that are added to the page.
      once('pronunciationScript', '.pronunciation', context).forEach((item) => {
        item.addEventListener('click', function () {
          const pronunciation = item.querySelector('.pronunciation_audio');
          pronunciation.querySelector('audio').play();
        });
      });
    }
  };
})(Drupal);
